import React, {useEffect, useState} from "react";
import InboxTable from './InboxTable'
import { OBPSService } from '../../../../../../libraries/src/services/elements/OBPS';


function PaymentDetails({type}){
    const tenantId = Digit.ULBService.getCurrentTenantId();
    const [apiData, setApiData] = useState(null);

    const fetchData = async (params) => {
      const result = await OBPSService.paymentDetailData(params);
      setApiData(result);
    };
    
      useEffect(async () => {
       await fetchData(tenantId)
      }, [])
    return(
            <InboxTable apiData={apiData} />
    )
}

export default PaymentDetails